<template>
  <div>
    <div class="layout miBcycle">
      <div class="system-setting">
        <!-- 主tab选择 -->
        <div
          class="layout-header-tab"
          style="width: calc(100% - 1.875rem); z-index: 22"
        >
          <template v-for="item in configJs">
            <span
              v-if="!item.isHide"
              @click="tabChange(item)"
              :key="item.id"
              :class="{ active: item.active || item.id === currTab.relativeId }"
              class="tab"
              >{{ item.name }}</span
            >
          </template>
        </div>
        <div style="height: 40px"></div>
        <!-- 副标题 -->
        <div
          v-show="
            currTab.isHide &&
            ['600', '700', '900', '300', '902', '104', '105'].includes(
              currTab.id
            )
          "
          style="
            width: calc(100% - 212px);
            position: fixed;
            z-index: 22;
            background-color: #f0f2f5;
          "
        >
          <div
            v-show="
              currTab.isHide &&
              (currTab.id === '700' ||
                currTab.id === '104' ||
                currTab.id === '105')
            "
            class="wgTpye-breadcrumb"
          >
            <span @click="wgTypeGo(1)" class="cursor">违规处理</span>
            <span>/</span>
            <span class="c0">{{
              currTab.id === "700" ? "违规类型设置" : "品牌报表"
            }}</span>
          </div>
          <div
            v-show="
              currTab.isHide && ['600', '900', '902'].includes(currTab.id)
            "
            class="wgTpye-breadcrumb"
          >
            <span @click="jwglGo(1)" class="cursor">角色管理</span>
            <span>/</span>
            <span class="c0">审核列表</span>
          </div>
        </div>
        <div
          ref="secondTitle"
          v-show="
            currTab.isHide &&
            ['600', '700', '900', '300', '902', '104', '105'].includes(
              currTab.id
            )
          "
          style="height: 43px"
        ></div>
        <!-- 检索区 - 展示 -->
        <div
          ref="searchBox"
          style="
            width: calc(100% - 1.875rem);
            padding: 16px;
            position: fixed;
            z-index: 22;
            background-color: #f0f2f5;
            right: 0.625rem;
          "
        >
          <div class="filters-container" style="width: 100%">
            <div class="title" v-show="!currTab.isHide || currTab.showtitle">
              {{ currTab.name }}
              <div style="float: right;margin-right: 1.25rem" v-if="currTab.titleRight">
                <template v-for="item in currTab.titleRight">
                  <component
                    v-show="checkUserAuth(72, item.permissionId)"
                    :is="'v-' + item.type"
                    :key="item.id"
                    :params="item"
                    @illegalOperation="illegalOperation"
                    @addWGType="addWGTypePre"
                    @onAuditList="onAuditList"
                    @addGgtz="addGgtzPre"
                    @addRule="addRulePre"
                    @addReport="addGgtzPre"
                  >
                  </component>
                </template>
              </div>
            </div>
            <!-- 第二层选择 -->
            <div class="sub-tab" v-if="currTab.children">
              <template v-for="item in currTab.children">
                <span
                  @click="subTabChange(item)"
                  :key="item.id"
                  :class="{ active: item.active }"
                  class="tab"
                  >{{ item.name }}</span
                >
              </template>
            </div>
            <!-- 检索框部分 -->
            <div class="filters-content flex" v-if="currTab.filters">
              <!-- 检索框部分: 左侧 -->
              <div class="f1 filters-left" v-if="currTab.filters.left">
                <el-form :inline="true" :model="form">
                  <template v-for="item in currTab.filters.left">
                    <component
                      v-if="!item.hide"
                      :ref="item.id"
                      :is="'form-' + item.type"
                      :key="item.id"
                      :params="item"
                      :rowData="rowData"
                      @numsDetele="numsDetelePre"
                      @csi="changeSearchItem"
                      @search="search"
                      @save="save"
                      @reset="reset"
                      @export="onExport"
                      @auditExport="onAuditExport"
                      @lineExport="onLineExport"
                      @installExport="onInstallExport"
                      @rejectExport="onRejectExport"
                      @noLineExport="onNoLineExport"
                      @multmatch="multmatchPre"
                      @shlb_zdgl_pass="shlb_zdgl_pass_pre"
                      @shlb_zdgl_reject="shlb_zdgl_reject_pre"
                      @changeType="changeType"
                    ></component>
                  </template>
                </el-form>
              </div>
              <!-- 检索框部分: 右侧 -->
              <div class="filters-right" v-if="currTab.filters.right">
                <template v-for="item in currTab.filters.right">
                  <component
                    v-show="checkUserAuth(72, item.permissionId)"
                    :is="'v-' + item.type"
                    :key="item.id"
                    :params="item"
                    @illegalOperation="illegalOperation"
                    @addWGType="addWGTypePre"
                    @onAuditList="onAuditList"
                    @addGgtz="addGgtzPre"
                    @addRule="addRulePre"
                    @addReport="addGgtzPre"
                  >
                  </component>
                </template>
              </div>
            </div>
          </div>
        </div>
        <!-- 表格区 -->
        <div
          class="layout-body m16 pagination-bg-white"
          v-if="!currTab.hideTable"
        >
          <!-- 检索区 - 隐藏 -->
          <div :style="{ height: searchHeight }"></div>
          <!-- 表格 -->
          <div class="table-container">
            <el-table
              v-if="currTab && (currTab.id == '663' || currTab.id == '667')"
              v-loading.body="tableLoading"
              :data="tableData"
              :style="{ height: tableViewHeight }"
              row-key="id"
            >
              <el-table-column
                v-for="item in staticData[currTab.tableColumnsName].columns"
                :key="item.id"
                :label="item.label"
                :prop="item.prop"
              >
                <template slot-scope="props">
                  <span v-if="props.column.label === '操作'">
                    <template v-if="currTab && currTab.tableButtons">
                      <template
                        v-if="
                          (currTab.id == '663' || currTab.id == '667') &&
                          props.row.istree
                        "
                      ></template>
                      <template v-for="btn in currTab.tableButtons" v-else>
                        <span
                          v-show="checkUserAuth(72, btn.permissionId)"
                          :key="btn.id"
                          v-if="
                            (btn.relativeKey &&
                              String(props.row[btn.relativeKey]) ===
                                btn.relativeValue) ||
                            !btn.relativeKey
                          "
                        >
                          <span class="gray" v-if="btn.bLine">｜</span>
                          <span
                            @click="onShowDialogFromTableBtn(props.row, btn)"
                            class="table-btn blue cursor"
                            >{{ btn.label }}</span
                          >
                        </span>
                      </template>
                    </template>
                  </span>
                  <span v-else>{{ props.row[props.column.property] }}</span>
                </template>
              </el-table-column>
            </el-table>
            <w-table
              v-else-if="
                currTab &&
                currTab.permissionId &&
                checkUserAuth(72, currTab.permissionId)
              "
              ref="table"
              v-loading.body="tableLoading"
              :height="tableViewHeight"
              :data-list="tableData"
              :columns="staticData[currTab.tableColumnsName].columns"
              :pageNo="currTab.pageNum"
              :pageSize="currTab.pageSize"
              :pageSizes="currTab.pageSizes"
              :total="currTab.total"
              @pageNoChange="pageNoChange"
              @pageSizeChange="pageSizeChange"
              :needSelection="currTab.needSelection"
              @selection-change="selectionChange"
              :bPagination="currTab.bPagination"
              :selectInit="currTab.selectInitFn && this[currTab.selectInitFn]"
            >
             <template slot-scope="props" slot="cell">
                <span v-if="props.column.label === '序号'">{{
                  props.index + 1 + (currTab.pageNum - 1) * currTab.pageSize
                }}</span>
                <span v-else-if="props.column.label === '品牌'">
                  {{
                    (props.row["brandIds"] || props.row["brandId"])
                      | filterBrandName(brands)
                  }}
                </span>
                <span v-else-if="props.column.label === '处理及时率'">
                  {{
                    !props.row["total"]
                      ? "0%"
                      : Math.round(
                          (props.row["timelyTotal"] / props.row["total"]) *
                            10000
                        ) /
                          100.0 +
                        "%"
                  }}
                </span>
                <span v-else-if="props.column.label === '合格率'">
                  {{
                    !props.row["total"]
                      ? "0%"
                      : Math.round(
                          (props.row["passTotal"] / props.row["total"]) * 10000
                        ) /
                          100.0 +
                        "%"
                  }}
                </span>
               <span v-else-if="props.column.label === '手机号码'
                   && (currTab.id == '500' || currTab.id == '800'|| currTab.id == '901'
                  || currTab.relativeId == '500' || currTab.relativeId == '800'|| currTab.relativeId == '901')">
                  {{ props.row["phone"] | hidePhoneNumber }}
                </span>
                <span v-else-if="props.column.label === '品牌公司'">
                  {{ props.row["brandId"] | filterBrandName(brands) }}
                </span>
                <span v-else-if="props.column.label === '类型'">
                  {{
                    props.row["accuseTypes"] | filterAccuseTypes(replyTypeList)
                  }}
                </span>
                <span v-else-if="props.column.label === '任务类型'">
                  {{ props.row["mold"] | filterMoldStatus }}
                </span>
                <span v-else-if="props.column.label === '分类'">
                  {{
                    props.row["examineInfo"]
                      ? JSON.parse(props.row["examineInfo"]).title
                      : "-"
                  }}
                </span>
                <span v-else-if="props.column.label === '地址'">
                  {{ props.row | getAreaNames(nationalArea) }}
                </span>
                <span v-else-if="props.column.label === '地区'">
                  {{
                    props.row
                      | getAreaNamesByAddress(
                        nationalArea,
                        userLevel,
                        userSelfAreaId
                      )
                  }}
                </span>
                <span v-else-if="props.column.label === '提交人'">
                  {{ props.row["submitName"] || props.row["reportName"] }}
                  <template v-if="props.row['isSupervise'] == 1">
                    <span class="pu">监</span>
                  </template>
                </span>
                <span v-else-if="props.column.label === '审核人'">
                  {{ props.row["checkUserName"] }}
                  <template
                    v-if="
                      props.row['auditLastRole'] &&
                      props.row['auditLastRole'] === 'monitor'
                    "
                  >
                    <span class="pu">管理员</span>
                  </template>
                </span>
                <span v-else-if="props.column.label === '申请人'">
                  {{ props.row["miUsersName"] || props.row["realname"] }}
                  <template v-if="props.row['isInvestigate'] === 0">
                    <span class="pu">普</span>
                  </template>
                </span>
                <span v-else-if="props.column.label === '状态'">
                  <template
                    v-if="
                      ['200', '1000', '1100', '1200', '1300'].includes(
                        String(currTab.id)
                      )
                    "
                  >
                    <span
                      :class="{
                        green:
                          Number(props.row.auditCurrent) === 2 &&
                          Number(props.row.applyStatus) === 0,
                      }"
                    >
                      {{ props.row | filterApplyStationStatus(currTab) }}
                    </span>
                  </template>
                  <template>
                    <span :class="{ red: Number(props.row['status']) === 0 }">
                      {{ props.row["status"] | filterStatus }}
                    </span>
                  </template>
                </span>
                <span v-else-if="props.column.label === '匹配状态'">
                  {{ props.row["matchStatus"] | filterMatchStatus }}
                </span>
                <span v-else-if="props.column.label === '整改时长'">
                  {{
                    (new Date(props.row["finishTime"]) -
                      new Date(props.row["createTime"]))
                      | formatTime
                  }}
                </span>
                <span v-else-if="props.column.label === '角色'">
                  <template v-if="['500'].includes(currTab.id)">
                    {{ props.row["maintainGroup"] | filterMaintainGroup }}
                  </template>
                  <template v-else>
                    {{ props.row["group"] | filterGroup }}
                  </template>
                </span>
                <span v-else-if="props.column.label === '起始站点'">
                  {{
                    `${
                      props.row["startSiteName"]
                        ? props.row["startSiteName"] : ""
                    }${
                      props.row["startSite"]
                        ? "(" + props.row["startSite"] + ")"
                        : ""
                    }`
                  }}
                  <p>
                    {{
                      `地址：${props.row["address"] ? props.row["address"] : "/"}`
                    }}
                  </p>
                  <p class="c025">
                    {{
                      props.row["startTime"] | dateFormat("yyyy-MM-dd hh:mm:ss")
                    }}
                  </p>
                </span>
                <span v-else-if="props.column.label === '结束站点'">
                  {{
                    `${
                      props.row["endSiteName"] ? props.row["endSiteName"] : ""
                    }`
                  }}
                  {{ props.row["endSite"] ? `(${props.row["endSite"]})` : "" }}
                  <p>
                    {{
                      props.row["endLon"]
                        ? `（E${props.row["endLon"]}, N${props.row["endLat"]}）`
                        : ""
                    }}
                  </p>
                  <p class="c025">
                    {{
                      props.row["endTime"] | dateFormat("yyyy-MM-dd hh:mm:ss")
                    }}
                  </p>
                </span>
                <span v-else-if="props.column.label === '调度员'">
                  <template
                    v-if="
                      props.row['startUserName'] != props.row['endUserName']
                    "
                  >
                    <span
                      class="blue cursor"
                      @click="showUserInfo(props.row['startUserId'])"
                    >
                      {{ props.row["startUserName"] }}
                    </span>
                    <span
                      @click="showUserInfo(props.row['endUserId'])"
                      class="blue cursor"
                    >
                      {{
                        props.row["endUserName"]
                          ? "; " + props.row["endUserName"]
                          : ""
                      }}
                    </span>
                  </template>
                  <template v-else>
                    <span
                      class="blue cursor"
                      @click="showUserInfo(props.row['startUserId'])"
                    >
                      {{ props.row["startUserName"] }}
                    </span>
                  </template>
                </span>
                <span v-else-if="props.column.label === '审核状态'">
                  <span
                    :class="{
                      red: props.row['applyStatus'] === 2,
                      green: props.row['applyStatus'] === 1,
                    }"
                  >
                    {{ props.row["applyStatus"] | filterApplyStatus }}
                  </span>
                </span>
                <span v-else-if="props.column.label === '创建时间'">
                  {{
                    props.row["createTime"] | dateFormat("yyyy-MM-dd hh:mm:ss")
                  }}
                </span>
                <span v-else-if="props.column.label === '操作'">
                  <template v-if="currTab && currTab.tableButtons">
                    <template v-for="btn in currTab.tableButtons">
                      <span
                        v-show="checkUserAuth(72, btn.permissionId)"
                        :key="btn.id"
                        v-if="
                          (btn.relativeKey &&
                            String(props.row[btn.relativeKey]) ===
                              btn.relativeValue) ||
                          (!btn.relativeKey && !btn.hide)
                        "
                      >
                        <span class="gray" v-if="btn.bLine">｜</span>
                        <span
                          @click="onShowDialogFromTableBtn(props.row, btn)"
                          class="table-btn blue cursor"
                          >{{ btn.label }}</span
                        >
                      </span>
                    </template>
                  </template>
                </span>
                <span v-else>{{ props.row[props.column.property] }}</span>
              </template>
              <template v-slot:respondStatus="{ text }">
                {{{'0':'未响应','50':'未响应(超时)','100':'已响应(超时)','200':'已响应(及时)'}[text]}}
              </template>
              <template v-slot:completeStatus="{ text }">
                {{{'0':'待完成','100':'未完成','200':'已完成','250':'异常终止'}[text]}}
              </template>
              <template v-slot:respondTime="{row}">
                {{row.completeDatetime?calculateDuration(row.createTime,row.completeDatetime):'-'}}
              </template>
              <template v-slot:TimeoutTime="{row}">
                {{row.respondDatetime?calculateDuration(row.createTime,row.respondDatetime):'-'}}
              </template>
            </w-table>
            <p v-else>您的账户没有权限查看此内容！</p>
          </div>
          <!-- <div>{{configJs}}</div> -->
        </div>
      </div>
    </div>
    <!-- 这里写浮层 一层-->
    <w-dialog
      ref="w-dialog"
      isShowFooter
      :title="dialogTitle"
      :width="miTableBtn.dialogWidth"
      @handleClose="onCloseDialog(1)"
      @handleCloseRight="onCloseDialog(2)"
      @onSure="onSureDialog"
      :isShowCancelBtn="miTableBtn.isShowCancelBtn"
      :isShowSureBtn="miTableBtn.isShowSureBtn"
      :cancelBtnText="miTableBtn.cancelBtnText"
      :sureBtnText="miTableBtn.sureBtnText"
      :class="{ gg: currTab.id === '400' }"
    >
      <template v-slot:content>
        <template v-if="miTableBtn && miTableBtn.showType === 'dialog-form'">
          <el-form :inline="true" :model="form" label-width="7.5rem">
            <el-row>
              <template v-for="item in miTableBtn.children">
                <el-col :span="24" :key="item.key + item.label">
                  <component
                    :ref="item.id"
                    :is="'form-' + item.component"
                    :params="item"
                    :rowData="rowData"
                    @csi="handleDialogFromChange"
                  ></component>
                </el-col>
              </template>
            </el-row>
          </el-form>
        </template>
        <template v-else-if="miTableBtn && miTableBtn.children">
          <template v-for="item in miTableBtn.children">
            <component
              :form.sync="form"
              :is="'v-' + item.component"
              :key="item.key + item.label"
              :params="item"
              :tableData="multipleSelection"
              :rowData="rowData"
            >
            </component>
          </template>
        </template>
      </template>
    </w-dialog>
    <!-- 这里写浮层 二层-->
    <w-dialog
      v-if="sureBtnClickContent"
      ref="w-two-dialog"
      isShowFooter
      :title="sureBtnClickContent.title"
      width="60%"
      @handleClose="onTwoCloseDialog"
      @handleCloseRight="onTwoCloseDialog"
      @onSure="onSureTwoDialog"
      :isShowCancelBtn="sureBtnClickContent.isShowCancelBtn"
      :isShowSureBtn="sureBtnClickContent.isShowSureBtn"
      :cancelBtnText="sureBtnClickContent.cancelBtnText"
      :sureBtnText="sureBtnClickContent.sureBtnText"
    >
      <template v-slot:content>
        <template v-if="sureBtnClickContent.showType === 'dialog-form'">
          <div v-if="sureBtnClickContent && sureBtnClickContent.children">
            <template v-for="item in sureBtnClickContent.children">
              <component
                :ref="item.id"
                :is="'form-' + item.component"
                :key="item.key + item.label"
                :params="item"
                :rowData="rowData"
                @csi="towDialogValueChange"
              ></component>
            </template>
          </div>
        </template>
        <template v-else-if="sureBtnClickContent.showType === 'dialog-text'">
          <template v-if="sureBtnClickContent && sureBtnClickContent.children">
            <template v-for="item in sureBtnClickContent.children">
              <component
                :is="'v-' + item.component"
                :key="item.key + item.label"
                :params="item"
                :rowData="rowData"
              >
              </component>
            </template>
          </template>
        </template>
      </template>
    </w-dialog>
    <w-dialog
      ref="w-examineDialog"
      title="选择导出字段"
      width="50%"
      sureBtnText="导出"
      @handleClose="handleCloseExport"
      @handleCloseRight="handleCloseExport"
      @onSure="onSureExport"
    >
      <template v-slot:content>
        <div class="dialog-content">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
          >全选
          </el-checkbox>
          <div style="margin: 0.9375rem 0"></div>
          <el-checkbox-group
            v-model="checkedCities"
            @change="handleCheckedCitiesChange"
          >
            <el-checkbox
              style="margin-bottom: 0.625rem"
              v-for="city in examineOptions"
              :label="city.key"
              :key="city.key"
            >{{ city.label }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
        <span style="color: red">*最多导出数据65500条</span>
      </template>
    </w-dialog>
    <!--站点申请——审核-->
    <w-dialog
      ref="w-auditDialog"
      title="选择导出字段"
      width="50%"
      sureBtnText="导出"
      @handleClose="handleAuditCloseExport"
      @handleCloseRight="handleAuditCloseExport"
      @onSure="onAuditSureExport"
    >
      <template v-slot:content>
        <div class="dialog-content">
          <el-checkbox
            :indeterminate="auditIsIndeterminate"
            v-model="auditCheckAll"
            @change="handleAuditCheckAllChange"
          >全选
          </el-checkbox>
          <div style="margin: 0.9375rem 0"></div>
          <el-checkbox-group
            v-model="auditCheckedCities"
            @change="handleAuditCheckedChange"
          >
            <el-checkbox
              style="margin-bottom: 0.625rem"
              v-for="city in auditOptions"
              :label="city.key"
              :key="city.key"
            >{{ city.label }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </template>
    </w-dialog>
    <!--站点申请——画线-->
    <w-dialog
      ref="w-lineDialog"
      title="选择导出字段"
      width="50%"
      sureBtnText="导出"
      @handleClose="handleLineCloseExport"
      @handleCloseRight="handleLineCloseExport"
      @onSure="onLineSureExport"
    >
      <template v-slot:content>
        <div class="dialog-content">
          <el-checkbox
            :indeterminate="lineIsIndeterminate"
            v-model="lineCheckAll"
            @change="handleLineCheckAllChange"
          >全选
          </el-checkbox>
          <div style="margin: 0.9375rem 0"></div>
          <el-checkbox-group
            v-model="lineCheckedCities"
            @change="handleLineCheckedChange"
          >
            <el-checkbox
              style="margin-bottom: 0.625rem"
              v-for="city in lineOptions"
              :label="city.key"
              :key="city.key"
            >{{ city.label }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </template>
    </w-dialog>
    <!--站点申请——安装-->
    <w-dialog
      ref="w-installDialog"
      title="选择导出字段"
      width="50%"
      sureBtnText="导出"
      @handleClose="handleInstallCloseExport"
      @handleCloseRight="handleInstallCloseExport"
      @onSure="onInstallSureExport"
    >
      <template v-slot:content>
        <div class="dialog-content">
          <el-checkbox
            :indeterminate="installIsIndeterminate"
            v-model="installCheckAll"
            @change="handleInstallCheckAllChange"
          >全选
          </el-checkbox>
          <div style="margin: 0.9375rem 0"></div>
          <el-checkbox-group
            v-model="installCheckedCities"
            @change="handleInstallCheckedChange"
          >
            <el-checkbox
              style="margin-bottom: 0.625rem"
              v-for="city in installOptions"
              :label="city.key"
              :key="city.key"
            >{{ city.label }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </template>
    </w-dialog>
    <!--站点申请——已拒绝-->
    <w-dialog
      ref="w-rejectDialog"
      title="选择导出字段"
      width="50%"
      sureBtnText="导出"
      @handleClose="handleRejectCloseExport"
      @handleCloseRight="handleRejectCloseExport"
      @onSure="onRejectSureExport"
    >
      <template v-slot:content>
        <div class="dialog-content">
          <el-checkbox
            :indeterminate="rejectIsIndeterminate"
            v-model="rejectCheckAll"
            @change="handleRejectCheckAllChange"
          >全选
          </el-checkbox>
          <div style="margin: 0.9375rem 0"></div>
          <el-checkbox-group
            v-model="rejectCheckedCities"
            @change="handleRejectCheckedChange"
          >
            <el-checkbox
              style="margin-bottom: 0.625rem"
              v-for="city in rejectOptions"
              :label="city.key"
              :key="city.key"
            >{{ city.label }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </template>
    </w-dialog>
    <!--站点申请——不可画线-->
    <w-dialog
      ref="w-noLineDialog"
      title="选择导出字段"
      width="50%"
      sureBtnText="导出"
      @handleClose="handleNoLineCloseExport"
      @handleCloseRight="handleNoLineCloseExport"
      @onSure="onNoLineSureExport"
    >
      <template v-slot:content>
        <div class="dialog-content">
          <el-checkbox
            :indeterminate="noLineIsIndeterminate"
            v-model="noLineCheckAll"
            @change="handleNoLineCheckAllChange"
          >全选
          </el-checkbox>
          <div style="margin: 0.9375rem 0"></div>
          <el-checkbox-group
            v-model="noLineCheckedCities"
            @change="handleNoLineCheckedChange"
          >
            <el-checkbox
              style="margin-bottom: 0.625rem"
              v-for="city in noLineOptions"
              :label="city.key"
              :key="city.key"
            >{{ city.label }}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </template>
    </w-dialog>
  </div>
</template>

<script>
// 公用
import Api from '@/api'
import configJs from './miBicycle'
// 公共组件
import WDialog from '@/components/Model/index.vue'
import WTable from '@/components/Table/index.vue'
// form 组件
import formButton from './components/form-button'
import formData from './components/form-data'
import formDataRange from './components/form-dataRange'
import formDataTime from './components/form-dataTime'
import formDateselect from './components/form-dateselect'
import formDataTimeRange from './components/form-dataTimeRange'
import formInput from './components/form-input'
import formAutocomplete from './components/form-autocomplete'
import formTextarea from './components/form-textarea'
import formSelect from './components/form-select'
import formStatictext from './components/form-statictext'
import formArea from './components/form-area'
import formAreaArea from './components/form-areaArea'
import formRadio from './components/form-radio.vue'
import formUpload from './components/form-upload.vue'
// 纯展示类组件
import vButton from './components/v-button'
import vText from './components/v-text'
import vTitle from './components/v-title'
import vGgContent from './components/v-gg-content'
import vGgInfo from './components/v-gg-info'
import vSteps from './components/v-steps'
import vImage from './components/v-image'
import vSelect from './components/v-select.vue'
import vTable from './components/v-table.vue'
import vStatictext from './components/v-statictext'
// vue应用
import { mapGetters } from 'vuex'
import staticData from './staticData.js'
import filters from './filters.js'
// mixins
import dialogLogic from './mixins/dialogLogic.js'
import weigType from './mixins/weigType.js'
import jsgl from './mixins/jsgl.js'
import zdsq from './mixins/zdsq.js'
// 模拟数据
// import wgjbMockData from './mock/wgjb.json'
import store from '../../store'
import { compare, downloadExcel, getFilterParams } from '@/utils/tools'

export default {
  name: 'miBic',
  mixins: [dialogLogic, weigType, jsgl, zdsq],
  filters,
  data() {
    return {
      searchHeight: '191px',
      configJs: undefined, // configJs // 在这里设置有缓存
      form: {},
      tableLoading: false,
      subTabName: 'scondKey',
      multipleSelection: [], // 当前table的已选项，当js数据当needSelection为true时使用
      tableViewHeight: '',
      // 系统考核导出
      examineOptions: [
        {
          key: 1,
          label: '序号'
        },
        {
          key: 2,
          label: '位置'
        },
        {
          key: 3,
          label: '任务编码'
        },
        {
          key: 4,
          label: '品牌'
        },
        {
          key: 5,
          label: '任务类型'
        },
        {
          key: 6,
          label: '创建时间'
        },
        {
          key: 7,
          label: '响应状态'
        },
        {
          key: 8,
          label: '完成状态'
        },
        {
          key: 9,
          label: '处理时间'
        },
        {
          key: 10,
          label: '超时时长'
        },
        {
          key: 11,
          label: '超时日期'
        },
        {
          key: 12,
          label: '完成日期'
        },
        {
          key: 13,
          label: '站点编号'
        },
        {
          key: 14,
          label: '站点名称'
        },
        {
          key: 15,
          label: '车辆编号'
        }
      ],
      checkedCities: [],
      isIndeterminate: true,
      checkAll: false,
      // 站点申请-审核
      auditCheckedCities: [],
      auditIsIndeterminate: true,
      auditCheckAll: false,
      auditOptions: [
        {
          key: 1,
          label: '序号'
        },
        {
          key: 2,
          label: '地区'
        },
        {
          key: 3,
          label: '位置'
        },
        {
          key: 4,
          label: '申请人'
        },
        {
          key: 5,
          label: '单位'
        },
        {
          key: 6,
          label: '申请时间'
        },
        {
          key: 7,
          label: '状态'
        },
        {
          key: 8,
          label: '审核人'
        },
        {
          key: 9,
          label: '审核时间'
        }
      ],
      // 站点申请-画线
      lineCheckedCities: [],
      lineIsIndeterminate: true,
      lineCheckAll: false,
      lineOptions: [
        {
          key: 1,
          label: '序号'
        },
        {
          key: 2,
          label: '地区'
        },
        {
          key: 3,
          label: '位置'
        },
        {
          key: 4,
          label: '审核人'
        },
        {
          key: 5,
          label: '单位'
        },
        {
          key: 6,
          label: '审核时间'
        },
        {
          key: 7,
          label: '状态'
        },
        {
          key: 8,
          label: '画线人'
        },
        {
          key: 9,
          label: '画线时间'
        }
      ],
      // 站点申请-安装
      installCheckedCities: [],
      installIsIndeterminate: true,
      installCheckAll: false,
      installOptions: [
        {
          key: 1,
          label: '序号'
        },
        {
          key: 2,
          label: '地区'
        },
        {
          key: 3,
          label: '位置'
        },
        {
          key: 4,
          label: '画线人'
        },
        {
          key: 5,
          label: '单位'
        },
        {
          key: 6,
          label: '画线时间'
        },
        {
          key: 7,
          label: '状态'
        },
        {
          key: 8,
          label: '安装人'
        },
        {
          key: 9,
          label: '安装时间'
        }
      ],
      // 站点申请-已拒绝
      rejectCheckedCities: [],
      rejectIsIndeterminate: true,
      rejectCheckAll: false,
      rejectOptions: [
        {
          key: 1,
          label: '序号'
        },
        {
          key: 2,
          label: '地区'
        },
        {
          key: 3,
          label: '位置'
        },
        {
          key: 4,
          label: '申请人'
        },
        {
          key: 5,
          label: '单位'
        },
        {
          key: 6,
          label: '申请时间'
        },
        {
          key: 7,
          label: '状态'
        },
        {
          key: 8,
          label: '审核人'
        },
        {
          key: 9,
          label: '审核时间'
        }
      ],
      // 站点申请-不可画线
      noLineCheckedCities: [],
      noLineIsIndeterminate: true,
      noLineCheckAll: false,
      noLineOptions: [
        {
          key: 1,
          label: '序号'
        },
        {
          key: 2,
          label: '地区'
        },
        {
          key: 3,
          label: '位置'
        },
        {
          key: 4,
          label: '审核人'
        },
        {
          key: 5,
          label: '单位'
        },
        {
          key: 6,
          label: '审核时间'
        },
        {
          key: 7,
          label: '状态'
        },
        {
          key: 8,
          label: '画线人'
        },
        {
          key: 9,
          label: '画线时间'
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'selfAreaId',
      'permissions',
      'brands',
      'user',
      'areaAll',
      'dispatcherList',
      'replyTypeList',
      'nationalArea',
      'userLevel',
      'userSelfAreaId',
      'userSelectAddressData'
    ]),
    aggregationId() {
      // 实体区的复合区Id
      return this.userSelectAddressData
        ? this.userSelectAddressData.aggregationId
        : undefined
    },
    aggregation() {
      // 0 - 实体区
      return this.userSelectAddressData
        ? this.userSelectAddressData.aggregation
        : undefined
    },
    staticData() {
      return staticData
    },
    isAggregation() {
      // 是否是非复合区下的实体区
      let falg = false
      if (this.aggregation !== undefined) {
        if (this.aggregation === 0 && this.aggregationId === '') {
          falg = false
        } else if (this.aggregation === 1 && this.aggregationId) {
          falg = false // 复合区不含有标识mold=1
        } else {
          falg = true // 复合区下的区
        }
      } else {
        falg = false
      }
      return falg
    },
    currTab() {
      return this.configJs.find((item) => item.active)
    },
    tableData() {
      return this.currTab.tableData
    }
  },
  created() {
    this.configJs = JSON.parse(JSON.stringify(configJs))
    this.getAllDispatcherList()
    this.getReplyTypeList()
    if (this.$route.params && this.$route.params.site) {
      this.tabChange(this.configJs[12])
    }
    if (this.$route.params && this.$route.params.role) {
      console.log(this.$route.params.role)
      this.tabChange(this.configJs[this.$route.params.role])
    }
  },
  mounted() {
    this.initData(this.getSearchParams())
    this.calcView()
  },
  methods: {
    calculateDuration(startTimeStr, endTimeStr) {
      // 将时间字符串转换为 Date 对象
      const startTime = new Date(startTimeStr)
      const endTime = new Date(endTimeStr)
      // 计算时间差（单位为毫秒），取绝对值，避免负值
      const durationInMs = Math.abs(endTime - startTime)
      // 计算天数、小时、分钟和秒数
      const days = Math.floor(durationInMs / (1000 * 60 * 60 * 24))
      const hours = Math.floor((durationInMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const minutes = Math.floor((durationInMs % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((durationInMs % (1000 * 60)) / 1000)
      // 构造显示字符串
      let result = ''
      if (days > 0) {
        result += `${days}天`
      }
      result += `${hours}时${minutes}分${seconds}秒`
      // 返回结果
      return result
    },
    // 计划视图区域
    calcView() {
      if (this.$refs.secondTitle) {
        this.$nextTick(() => {
          let H = 40
          if (this.$refs.secondTitle && this.$refs.secondTitle.clientHeight) {
            H += Number(this.$refs.secondTitle.clientHeight)
          }
          if (this.$refs.searchBox && this.$refs.searchBox.clientHeight) {
            H += Number(this.$refs.searchBox.clientHeight)
          }
          // console.log('H', H)
          // 56: 导航栏高度修正
          // 79: table分页器高度修正
          // px 转为rem
          if (window.innerWidth <= 1920) {
            this.tableViewHeight = (window.innerHeight - 56 - H - 65)
            this.searchHeight = (this.$refs.searchBox.clientHeight - 16) / 16 + 'rem'
          } else { // 2k屏幕自适应
            this.tableViewHeight = (window.innerHeight - 56 - H - 120)
            this.searchHeight = (this.$refs.searchBox.clientHeight - 76) / 16 + 'rem'
          }
        })
      }
    },
    // 表格处理
    pageNoChange(page) {
      const currTab = this.configJs.find((item) => item.active)
      currTab.pageNum = page
      this.refreshPage(currTab)
    },
    pageSizeChange(size) {
      const currTab = this.configJs.find((item) => item.active)
      currTab.pageSize = size
      this.refreshPage(currTab)
    },
    selectionChange(e) {
      console.log(e)
      this.multipleSelection = []
      if (
        this.currTab.name == '扫一扫巡查' ||
        this.currTab.name == '嗅探巡查'
      ) {
        this.multipleSelection = e
        return
      }
      if (e && e.length) {
        e.forEach((item) => {
          this.multipleSelection.push(item.id)
        })
      }
    },
    handleDialogFromChange(e) {
      // console.log('handleDialogFromChange', e)
    },
    shlb_zdgl_selectInitFn(e) {
      if (Number(e.applyStatus) === 0) {
        return true
      }
      return false
    },
    // Api处理区
    initData(sd) {
      const vm = this
      if (
        vm.currTab.permissionId &&
        !vm.checkUserAuth(72, vm.currTab.permissionId)
      ) {
        console.log('没有列表权限，', vm.currTab)
        return
      }
      vm.tableLoading = true
      let params = {}
      if (this.currTab.id == 660 || this.currTab.id == 665) {
        params.matchStatus = 3 // 匹配成功列表默认是3
      }
      params.selfAreaId = this.selfAreaId
      params.currentPage = this.currTab.pageNum
      params.pageSize = this.currTab.pageSize
      if (sd) {
        params = Object.assign(params, sd)
        if (params.matchStatus == 123) {
          delete params.matchStatus
        }
      }

      Api.fetchApiGet(params, this.currTab.api).then((res) => {
        // console.log('initData 数据源：', res)
        if (res.code === 200) {
          const currTab = this.configJs.find((item) => item.active)
          if (this.currTab.initTranslate) {
            this.initTranslate(res.data)
          }
          if (res.data && !res.data.list) {
            if (currTab.id == '104' || currTab.id == '105') {
              const aa = res.data.reduce(
                (pre, cur) => {
                  pre.dealTotal += cur.dealTotal
                  pre.notDealTotal += cur.notDealTotal
                  pre.notTimelyTotal += cur.notTimelyTotal
                  pre.passTotal += cur.passTotal
                  pre.timelyTotal += cur.timelyTotal
                  pre.total += cur.total
                  return pre
                },
                {
                  dealTotal: 0,
                  notDealTotal: 0,
                  notTimelyTotal: 0,
                  passTotal: 0,
                  timelyTotal: 0,
                  total: 0
                }
              )
              res.data.push({
                ...{
                  title: '总体情况',
                  id: 0
                },
                ...aa
              })
            } else if (currTab.id == '663' || currTab.id == '667') {
              console.log(666, res.data)
              const bikes = this.brands.map((val, index) => {
                return {
                  brandName: val.brandName,
                  brandId: val.brandId,
                  id: val.brandId,
                  istree: true,
                  children: []
                }
              })
              res.data.forEach((val) => {
                for (const brand of bikes) {
                  if (val.brandId == brand.brandId) {
                    val.brandName = ''
                    brand.children.push(val)
                  }
                }
              })
              res.data = bikes.filter((val) => {
                return val.children.length > 0
              })
            }
            this.$set(currTab, 'tableData', res.data)
            if (currTab.id == 903) {
              this.$set(this.rowData, 'time', res.data)
            } else if (currTab.id == 664) {
              this.rowData = res.data
            }
          } else {
            this.$set(currTab, 'tableData', res.data ? res.data.list : [])
            this.$set(currTab, 'total', res.data ? res.data.total : 0)
          }
          vm.calcView()
        } else {
          vm.$message.warning(res && res.message)
        }
        vm.tableLoading = false
      })
    },
    // 待画线 ：
    // auditCurrent === 3 && applyStatus === 0 && auditLastCurrent === -1 && auditLastUsersId === user.id
    // 已拒绝：
    // auditCurrent === 2 && applyStatus === 3 && auditLastCurrent === -1 && auditLastUsersId === user.id
    initTranslate(data) {
      if (data && data.list) {
        data.list.forEach((item) => {
          if (
            (Number(item.auditCurrent) === 3 &&
              Number(item.applyStatus) === 0 &&
              Number(item.auditLastCurrent) === -1 &&
              Number(item.auditLastUsersId) === Number(this.user.id)) ||
            (Number(item.auditCurrent) === 2 &&
              Number(item.applyStatus) === 3 &&
              Number(item.auditLastCurrent) === -1 &&
              Number(item.auditLastUsersId) === Number(this.user.id))
          ) {
            this.$set(item, 'hasReturn', '1')
          }
        })
      }
    },
    // 搜索处理区
    // 获取默认搜索项
    getSearchDefaultParams(id) {
      const params = {}
      const currTab = this.configJs.find((item) => item.id === String(id))
      if (currTab && currTab.filters && currTab.filters.left) {
        currTab.filters.left.forEach((item) => {
          if (item.dValue) {
            params[item.key] = item.dValue
          }
        })
      }
      return params
    },
    // 获取当前搜索项
    // 给查询按钮使用，处理当前页面的逻辑，切换页面有问题
    getSearchParams() {
      let params = {}
      const currTab = this.configJs.find((item) => item.active)
      currTab.pageNum = 1
      currTab.pageSize = currTab.defaultPageSize
      const refs = this.$refs
      for (const key in refs) {
        const vCom = refs[key] ? refs[key][0] : refs[key]
            console.log(vCom);
        if (
          vCom &&
          vCom.getValue &&
          (vCom.getValue() || vCom.getValue() === 0)
        ) {
          console.log(vCom.getValue(), 1)
          params = Object.assign(params, vCom.getValue())
        }
      }
      return params
    },
    // 给切换页面使用，根据js处理数据
    asyncGetSearchParams(currId) {
      const params = {}
      const curr = this.configJs.find((item) => item.id === String(currId))
      if (curr && curr.filters && curr.filters.left) {
        curr.filters.left.forEach((item) => {
          if (['select', 'input', 'data'].includes(item.type)) {
            if (!!item.value||item.value===0) {
              params[item.key] = item.value
            }
          } else if (item.type === 'dataRange') {
            if (item.start) {
              params.start = item.start
            }
            if (item.end) {
              params.end = item.end
            }
          } else if (item.type === 'dateselect') {
            params.startTime = this.dayjs(item.dValue)
              .startOf('M')
              .format('YYYY-MM-DD HH:mm:ss')
            params.endTime = this.dayjs(item.dValue)
              .endOf('M')
              .format('YYYY-MM-DD HH:mm:ss')
          }
        })
      }
      return params
    },
    save(target) {
      if (this.isAggregation) {
        this.$message.warning('复合区子区域无法添加，请在复合区添加！')
        return
      }
      // 保存违规处理时间
      const vm = this
      const data = this.getSearchParams()
      const params = {
        selfAreaId: vm.selfAreaId
      }
      // console.log(target);
      Api.fetchApiPost(data, params, target.api)
        .then((res) => {
          // 刷新页面
          if (res && res.code === 200) {
            vm.$message.success(
              target.parentId == 664
                ? '时间设置保存成功！'
                : '设置违规时间成功！'
            )
            const currTab = vm.configJs.find((item) => item.active)
            vm.refreshPage(currTab)
          } else {
            vm.$message.warning(res && res.message)
          }
        })
        .catch((err) => {
          console.log('saveTime', err)
        })
    },
    search(target) {
      const params = this.getSearchParams()
      console.log('search', target, params)
      this.clearData()
      this.initData(params)
    },
    changeType() {
      this.clearData()
      this.initData()
    },
    // 给重置按钮使用，处理当前页面的逻辑，切换页面有问题
    reset(target, onlyReset) {
      const refs = this.$refs
      for (const key in refs) {
        const vCom = refs[key][0]
        if (vCom && vCom.reset) {
          vCom.reset()
        }
      }
      if (!onlyReset) {
        this.search(target)
      }
    },
    // 给切换页面使用，根据js处理数据
    asyncReset(curr) {
      if (curr && curr.filters && curr.filters.left) {
        curr.filters.left.forEach((item) => {
          if (['select', 'input', 'data'].includes(item.type)) {
            if (item.dValue) {
              item.value = item.dValue
            } else {
              item.value = undefined
            }
          } else if (item.type === 'dataRange') {
            item.value = undefined
            item.start = undefined
            item.end = undefined
          }
        })
      }
    },
    addGgtzPre(target) {
      const vm = this
      vm.onShowDialogFromTableBtn(null, target)
    },
    addRulePre(target) {
      if (
        target &&
        (target.id === '663-b-1' || target.id === '667-b-1') &&
        this.isAggregation
      ) {
        this.$message.warning('复合区子区域无法添加规则设置，请在复合区添加！')
        return
      }
      this.onShowDialogFromTableBtn(null, target)
    },
    addRule() {
      console.log('addRule', this.$refs)
      const vm = this
      const pid = this.miTableBtn.id
      const data = {}
      for (const key in this.$refs) {
        if (key.indexOf(pid) > -1 && this.$refs[key].length) {
          const vc = this.$refs[key][0]
          const name = vc.params.label
          let ikey = vc.params.key
          const value = vc.getValue()
          console.log(name, ikey, value)
          if (value && (value[ikey] || value[ikey] === 0)) {
            if (ikey == '_brandId') {
              ikey = 'brandId'
              data[ikey] = value._brandId
            } else {
              data[ikey] = value[ikey]
            }
          } else {
            if (ikey != 'bikeIdExtractStart' && ikey != 'bikeIdExtractLength') {
              return this.$message.error(
                '请填写' + name.replace(':', '').replace('：', '')
              )
            }
          }
        }
      }
      const params = {
        selfAreaId: vm.selfAreaId
      }
      Api.fetchApiPost(data, params, vm.miTableBtn.api)
        .then((res) => {
          // 刷新页面
          if (res && res.code === 200) {
            vm.$message.success('匹配规则添加成功！')
            vm.onCloseDialog()
            const currTab = vm.configJs.find((item) => item.active)
            vm.refreshPage(currTab)
          } else {
            vm.$message.warning(res && res.message)
          }
        })
        .catch((err) => {
          console.log('addRule', err)
        })
    },
    editRule() {
      const vm = this
      const pid = this.miTableBtn.id
      const data = {
        id: this.rowData.id,
        brandId: this.rowData.brandId
      }
      for (const key in this.$refs) {
        if (key.indexOf(pid) > -1 && this.$refs[key].length) {
          const vc = this.$refs[key][0]
          const name = vc.params.label
          const ikey = vc.params.key
          const value = vc.getValue()
          console.log(name, ikey, value)
          if (value && (value[ikey] || value[ikey] === 0)) {
            data[ikey] = value[ikey]
          } else {
            if (ikey != 'bikeIdExtractStart' && ikey != 'bikeIdExtractLength') {
              return this.$message.error(
                '请填写' + name.replace(':', '').replace('：', '')
              )
            } else {
              data[ikey] = 0
            }
          }
        }
      }
      const params = {
        selfAreaId: vm.selfAreaId
      }
      const url = pid == '667-tb-1' ? Api.editRuleMac : Api.editRule
      url(data, params)
        .then((res) => {
          // 刷新页面
          if (res && res.code === 200) {
            vm.$message.success('规则修改成功!')
            vm.onCloseDialog()
            const currTab = vm.configJs.find((item) => item.active)
            vm.refreshPage(currTab)
          } else {
            vm.$message.warning(res && res.message)
          }
        })
        .catch((err) => {
          console.log('editRule', err)
        })
    },
    numsDetelePre(target) {
      // 批量删除前置校验
      const vm = this
      if (vm.multipleSelection && !vm.multipleSelection.length) {
        return vm.$message.error('请先选择要删除的记录！')
      }
      vm.onShowDialogFromTableBtn(null, target)
    },
    multmatchPre(target) {
      const vm = this
      if (vm.multipleSelection && !vm.multipleSelection.length) {
        return vm.$message.error('请先选择要匹配的车辆！')
      }
      vm.onShowDialogFromTableBtn(null, target)
    },
    multmatch(target) {
      // 批量匹配车企
      if (!this.form.brandId) {
        this.$message.error('请选择车辆品牌')
        return
      }
      let data = {
        bikeIds: this.multipleSelection.map((val) => val.bikeId).join(','),
        brandId: this.form.brandId,
        selfAreaId: this.selfAreaId
      }
      let url = Api.multMatchBrand
      if (target == 'mac') {
        url = Api.multMatchMac
        data = {
          bikeMacs: this.multipleSelection.map((val) => val.bikeMac).join(','),
          brandId: this.form.brandId,
          selfAreaId: this.selfAreaId
        }
      }
      url(data)
        .then((res) => {
          if (res && res.code === 200) {
            this.$message.success('批量匹配成功！')
            this.onCloseDialog(1)
            this.form = {}
            const currTab = this.configJs.find((item) => item.active)
            this.refreshPage(currTab)
          } else {
            this.$message.warning(res && res.message)
          }
        })
        .catch((err) => {
          console.log('multMatchBrand', err)
        })
    },
    numsDetele(target) {
      if (target == 'bikeNotUpload' || target == 'bikeNotUploadMac') {
        this.bikeDetele(target)
        return
      }
      // 批量删除
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId
      }
      const data = {
        ids: vm.multipleSelection.join(',')
      }
      vm.postApiPre(data, params, '/api/miApp/deleteReports')
        .then((res) => {
          if (res && res.code === 200) {
            vm.$message.success('违规举报批量删除成功！')
            vm.onCloseDialog()
            // 刷新页面
            const currTab = vm.configJs.find((item) => item.active)
            vm.refreshPage(currTab)
          } else {
            vm.$message.warning(res && res.message)
          }
        })
        .catch((err) => {
          console.log('the numsDetele has problem: ', err)
        })
    },
    bikeDetele(type) {
      // 批量删除
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId
      }
      var url = Api.deleteBikeNot
      var data = {
        bikeIds: vm.multipleSelection.map((val) => val.bikeId).join(',')
      }
      if (type == 'bikeNotUploadMac') {
        url = Api.deleteBikeNotMac
        data = {
          bikeMacs: vm.multipleSelection.map((val) => val.bikeMac).join(',')
        }
      }
      url(data, params)
        .then((res) => {
          if (res && res.code === 200) {
            vm.$message.success('批量删除成功！')
            vm.onCloseDialog()
            // 刷新页面
            const currTab = vm.configJs.find((item) => item.active)
            vm.refreshPage(currTab)
          } else {
            vm.$message.warning(res && res.message)
          }
        })
        .catch((err) => {
          console.log('the bikeDetele has problem: ', err)
        })
    },
    onAuditList(target) {
      // 审核列表
      console.log('审核列表', target)
      this.tabChange({
        id: target.tabChangeId
      })
    },
    illegalOperation(target) {
      // 违规类型操作
      // console.log('违规类型操作', target)
      if (target && target.relativeId) {
        this.translateActive(target.relativeId, true, undefined, true)
      }
    },
    changeSearchItem(cp) {
      this.translateValue('filters', 'left', cp)
    },
    tabChange(item) {
      this.translateActive(item.id, true, undefined, true)
    },
    subTabChange(item) {
      if (item && item.relativeId) {
        this.translateActive(item.relativeId, false, true, false)
      } else {
        this.translateSubTabActive(item)
      }
    },
    refreshPage(curr) {
      let params = {}
      params.currentPage = curr.pageNum
      params.pageSize = curr.pageSize
      // curr的children需要作为参数的使用
      // if (curr.children) {
      //   const subTabCurr = curr.children.find(item => item.active)
      //   params[this.subTabName] = subTabCurr.name
      // }
      // 加入search
      if (curr.name === '系统考核') {
        const refs = this.$refs
        for (const key in refs) {
          const vCom = refs[key] ? refs[key][0] : refs[key]
          if (
            vCom &&
            vCom.getValue &&
            (vCom.getValue() || vCom.getValue() === 0)
          ) {
            console.log(vCom.getValue(), 1)
            params = Object.assign(params, vCom.getValue())
          }
        }
      } else {
        params = Object.assign(params, this.asyncGetSearchParams(curr.id))
      }
      this.clearData()
      console.log(params)
      this.initData(params)
    },
    // 数据处理区
    // -修改js的active ,
    // isRefreshSubTab - 是否重置subTab,
    // doRefresh - true:手动刷新
    // doReset - true:表示不重置search参数
    translateActive(id, isRefreshSubTab, doRefresh, doReset) {
      this.cacheCurrTab = JSON.parse(JSON.stringify(this.currTab))
      if (this.cacheCurrTab && this.cacheCurrTab.id === '800' && id === '600') {
        id = '900'
      }
      if (this.cacheCurrTab && this.cacheCurrTab.id === '900' && id === '500') {
        id = '800'
      }
      this.configJs.forEach((item) => (item.active = false))
      const currTab = this.configJs.find((item) => item.id === id)
      currTab.active = true
      // 是否缓存 currTab.cached 为 false 刷新页面
      if (!currTab.cached || !currTab.tableData || doRefresh) {
        currTab.pageNum = 1
        currTab.pageSize = currTab.defaultPageSize
        if (isRefreshSubTab && currTab.children) {
          // 刷新subTab
          // 新增参数，保持按钮的稳定性
          // currTab.children.forEach(item => {
          // item.active = false
          // })
          // currTab.children[index].active = true
        }
        // 刷新filter
        if (doReset) {
          this.asyncReset(currTab)
        }
        this.refreshPage(currTab)
      }
      // 手动清除一些值
      this.clearData()
    },
    clearData() {
      this.multipleSelection = []
      if (
        this.$refs &&
        this.$refs.table &&
        this.$refs.table.$children &&
        this.$refs.table.$children.length
      ) {
        this.$refs.table.$children.forEach(
          (ref) => ref.clearSelection && ref.clearSelection()
        )
      }
    },
    translateSubTabActive(d) {
      const currTab = this.configJs.find((item) => item.id === d.parentId)
      currTab.children.forEach((item) => (item.active = false))
      const subTab = currTab.children.find((item) => item.id === d.id)
      subTab.active = true
      this.translateActive(d.parentId, false, true, false)
    },
    // -修改js的value
    translateValue(ft, st, d) {
      if (ft && st && d) {
        console.log(ft, st, d)
        const currTab = this.configJs.find((item) => item.id === d.parentId)
        const currFilter = currTab[ft][st].find((item) => {
          return item.id === d.id
        })
        this.$set(currFilter, 'value', d.value)
        // 时间区间 单独处理
        if (d.type === 'dataRange') {
          this.$set(currFilter, 'start', d.start)
          this.$set(currFilter, 'end', d.end)
        }
      }
    },
    // 获取全量违规类型
    getReplyTypeList() {
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId
      }
      Api.fetchApiGet(params, '/api/miApp/getReplyTypeList')
        .then((res) => {
          store
            .dispatch('globalVariable/activeSave', {
              key: 'replyTypeList',
              value: res.data
            })
            .then(() => {
              console.log('getReplyTypeList save success!!!')
            })
        })
        .catch((err) => {
          console.log('the getReplyTypeList has problem:', err)
        })
    },
    // 获取全量调度员
    getAllDispatcherList() {
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId
      }
      Api.fetchApiGet(params, '/api/miApp/getAllDispatcherList')
        .then((res) => {
          store
            .dispatch('globalVariable/activeSave', {
              key: 'dispatcherList',
              value: res.data
            })
            .then(() => {
              // console.log('dispatcherList save success!!!')
            })
        })
        .catch((err) => {
          console.log('the getAllDispatcherList has problem:', err)
        })
    },
    showUserInfo(id) {
      console.log('showUserInfo', id)
      const target = this.currTab.ddy
      const row = this.dispatcherList.find((item) => item.id === id)
      this.onShowDialogFromTableBtn(row, target)
    },
    matchAuto(type) {
      // 批量匹配车企
      let data = {
        bikeIds: this.rowData.bikeId,
        brandId: this.form.brandId,
        selfAreaId: this.selfAreaId
      }
      let url = Api.multMatchBrand
      if (type == 'mac') {
        url = Api.multMatchMac
        data = {
          bikeMacs: this.rowData.bikeMac,
          brandId: this.form.brandId,
          selfAreaId: this.selfAreaId
        }
      }
      url(data)
        .then((res) => {
          if (res && res.code === 200) {
            this.onCloseDialog(1)
            this.$message.success('手动匹配成功！')
            this.form = {}
            const currTab = this.configJs.find((item) => item.active)
            this.$nextTick(() => {
              this.refreshPage(currTab)
            })
          } else {
            this.$message.warning(res && res.message)
          }
        })
        .catch((err) => {
          console.log('multMatchBrand', err)
        })
    },
    onExport() {
      const vm = this
      const currTab = this.configJs.find((item) => item.active)
      if (currTab.total > 0) {
        this.$refs['w-examineDialog'].onShowDialog()
      } else {
        vm.$message.warning('请选择导出数据！')
      }
    },
    handleCloseExport() {
      this.checkedCities = []
      this.isIndeterminate = true
      this.checkAll = false
      this.$refs['w-examineDialog'].onCloseDialog()
    },
    handleCheckAllChange(val) {
      console.log(val)
      this.checkedCities = val ? this.examineOptions.map((it) => it.key) : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.examineOptions.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.examineOptions.length
    },
    // 确认导出
    onSureExport() {
      const vm = this
      vm.tableLoading = true
      const params = this.getSearchParams()
      let data = {}
      if (vm.searchData) {
        data = {
          ...vm.searchData
        }
      }
      data.selfAreaId = vm.selfAreaId
      data.userId = vm.user.id
      data.export =
        vm.checkedCities && vm.checkedCities.length
          ? vm.checkedCities.sort(compare).join(',')
          : ''
      data.status = 6
      data = getFilterParams(data)
      const newParams = Object.assign(data, params)
      if (data.export) {
        Api.exportSysExamineList(this.selfAreaId, newParams).then((res) => {
          if (res.code === 200) {
            downloadExcel(res.data)
            vm.tableLoading = false
            vm.handleCloseExport()
          } else {
            vm.$message.warning(res.message)
          }
          vm.tableLoading = false
        })
      } else {
        vm.$message.warning('请选择导出字段！')
        vm.tableLoading = false
      }
    },
    // 站点申请 - 审核
    onAuditExport() {
      const vm = this
      const currTab = this.configJs.find((item) => item.active)
      if (currTab.total > 0) {
        this.$refs['w-auditDialog'].onShowDialog()
      } else {
        vm.$message.warning('请选择导出数据！')
      }
    },
    handleAuditCloseExport() {
      this.auditCheckedCities = []
      this.auditIsIndeterminate = true
      this.auditCheckAll = false
      this.$refs['w-auditDialog'].onCloseDialog()
    },
    handleAuditCheckAllChange(val) {
      console.log(val)
      this.auditCheckedCities = val ? this.auditOptions.map((it) => it.key) : []
      this.auditIsIndeterminate = false
    },
    handleAuditCheckedChange(value) {
      const checkedCount = value.length
      this.auditCheckAll = checkedCount === this.auditOptions.length
      this.auditIsIndeterminate =
        checkedCount > 0 && checkedCount < this.auditOptions.length
    },
    // 确认导出
    onAuditSureExport() {
      const vm = this
      vm.tableLoading = true
      const params = this.getSearchParams()
      let data = {}
      if (vm.searchData) {
        data = {
          ...vm.searchData
        }
      }
      data.selfAreaId = vm.selfAreaId
      data.export =
        vm.auditCheckedCities && vm.auditCheckedCities.length
          ? vm.auditCheckedCities.sort(compare).join(',')
          : ''
      data = getFilterParams(data)
      const newParams = Object.assign(data, params)
      if (data.export) {
        Api.exportCheckList(this.selfAreaId, newParams).then((res) => {
          if (res.code === 200) {
            downloadExcel(res.data)
            vm.tableLoading = false
            vm.handleAuditCloseExport()
          } else {
            vm.$message.warning(res.message)
          }
          vm.tableLoading = false
        })
      } else {
        vm.$message.warning('请选择导出字段！')
        vm.tableLoading = false
      }
    },
    // 站点申请 - 画线
    onLineExport() {
      const vm = this
      const currTab = this.configJs.find((item) => item.active)
      if (currTab.total > 0) {
        this.$refs['w-lineDialog'].onShowDialog()
      } else {
        vm.$message.warning('请选择导出数据！')
      }
    },
    handleLineCloseExport() {
      this.lineCheckedCities = []
      this.lineIsIndeterminate = true
      this.lineCheckAll = false
      this.$refs['w-lineDialog'].onCloseDialog()
    },
    handleLineCheckAllChange(val) {
      console.log(val)
      this.lineCheckedCities = val ? this.lineOptions.map((it) => it.key) : []
      this.lineIsIndeterminate = false
    },
    handleLineCheckedChange(value) {
      const checkedCount = value.length
      this.lineCheckAll = checkedCount === this.lineOptions.length
      this.lineIsIndeterminate =
        checkedCount > 0 && checkedCount < this.lineOptions.length
    },
    // 确认导出
    onLineSureExport() {
      const vm = this
      vm.tableLoading = true
      const params = this.getSearchParams()
      let data = {}
      if (vm.searchData) {
        data = {
          ...vm.searchData
        }
      }
      data.selfAreaId = vm.selfAreaId
      data.export =
        vm.lineCheckedCities && vm.lineCheckedCities.length
          ? vm.lineCheckedCities.sort(compare).join(',')
          : ''
      data = getFilterParams(data)
      const newParams = Object.assign(data, params)
      if (data.export) {
        Api.exportLineList(this.selfAreaId, newParams).then((res) => {
          if (res.code === 200) {
            downloadExcel(res.data)
            vm.tableLoading = false
            vm.handleLineCloseExport()
          } else {
            vm.$message.warning(res.message)
          }
          vm.tableLoading = false
        })
      } else {
        vm.$message.warning('请选择导出字段！')
        vm.tableLoading = false
      }
    },
    // 站点申请 - 安装
    onInstallExport() {
      const vm = this
      const currTab = this.configJs.find((item) => item.active)
      if (currTab.total > 0) {
        this.$refs['w-installDialog'].onShowDialog()
      } else {
        vm.$message.warning('请选择导出数据！')
      }
    },
    handleInstallCloseExport() {
      this.installCheckedCities = []
      this.installIsIndeterminate = true
      this.installCheckAll = false
      this.$refs['w-installDialog'].onCloseDialog()
    },
    handleInstallCheckAllChange(val) {
      console.log(val)
      this.installCheckedCities = val ? this.installOptions.map((it) => it.key) : []
      this.installIsIndeterminate = false
    },
    handleInstallCheckedChange(value) {
      const checkedCount = value.length
      this.installCheckAll = checkedCount === this.installOptions.length
      this.installIsIndeterminate =
        checkedCount > 0 && checkedCount < this.installOptions.length
    },
    // 确认导出
    onInstallSureExport() {
      const vm = this
      vm.tableLoading = true
      const params = this.getSearchParams()
      let data = {}
      if (vm.searchData) {
        data = {
          ...vm.searchData
        }
      }
      data.selfAreaId = vm.selfAreaId
      data.export =
        vm.installCheckedCities && vm.installCheckedCities.length
          ? vm.installCheckedCities.sort(compare).join(',')
          : ''
      data = getFilterParams(data)
      const newParams = Object.assign(data, params)
      if (data.export) {
        Api.exportInstallList(this.selfAreaId, newParams).then((res) => {
          if (res.code === 200) {
            downloadExcel(res.data)
            vm.tableLoading = false
            vm.handleInstallCloseExport()
          } else {
            vm.$message.warning(res.message)
          }
          vm.tableLoading = false
        })
      } else {
        vm.$message.warning('请选择导出字段！')
        vm.tableLoading = false
      }
    },
    // 站点申请 - 已拒绝
    onRejectExport() {
      const vm = this
      const currTab = this.configJs.find((item) => item.active)
      if (currTab.total > 0) {
        this.$refs['w-rejectDialog'].onShowDialog()
      } else {
        vm.$message.warning('请选择导出数据！')
      }
    },
    handleRejectCloseExport() {
      this.rejectCheckedCities = []
      this.rejectIsIndeterminate = true
      this.rejectCheckAll = false
      this.$refs['w-rejectDialog'].onCloseDialog()
    },
    handleRejectCheckAllChange(val) {
      console.log(val)
      this.rejectCheckedCities = val ? this.rejectOptions.map((it) => it.key) : []
      this.rejectIsIndeterminate = false
    },
    handleRejectCheckedChange(value) {
      const checkedCount = value.length
      this.rejectCheckAll = checkedCount === this.rejectOptions.length
      this.rejectIsIndeterminate =
        checkedCount > 0 && checkedCount < this.rejectOptions.length
    },
    // 确认导出
    onRejectSureExport() {
      const vm = this
      vm.tableLoading = true
      const params = this.getSearchParams()
      let data = {}
      if (vm.searchData) {
        data = {
          ...vm.searchData
        }
      }
      data.selfAreaId = vm.selfAreaId
      data.export =
        vm.rejectCheckedCities && vm.rejectCheckedCities.length
          ? vm.rejectCheckedCities.sort(compare).join(',')
          : ''
      data = getFilterParams(data)
      const newParams = Object.assign(data, params)
      if (data.export) {
        Api.exportRejectList(this.selfAreaId, newParams).then((res) => {
          if (res.code === 200) {
            downloadExcel(res.data)
            vm.tableLoading = false
            vm.handleRejectCloseExport()
          } else {
            vm.$message.warning(res.message)
          }
          vm.tableLoading = false
        })
      } else {
        vm.$message.warning('请选择导出字段！')
        vm.tableLoading = false
      }
    },
    // 站点申请 - 不可画线
    onNoLineExport() {
      const vm = this
      const currTab = this.configJs.find((item) => item.active)
      if (currTab.total > 0) {
        this.$refs['w-noLineDialog'].onShowDialog()
      } else {
        vm.$message.warning('请选择导出数据！')
      }
    },
    handleNoLineCloseExport() {
      this.noLineCheckedCities = []
      this.noLineIsIndeterminate = true
      this.noLineCheckAll = false
      this.$refs['w-noLineDialog'].onCloseDialog()
    },
    handleNoLineCheckAllChange(val) {
      console.log(val)
      this.noLineCheckedCities = val ? this.noLineOptions.map((it) => it.key) : []
      this.noLineIsIndeterminate = false
    },
    handleNoLineCheckedChange(value) {
      const checkedCount = value.length
      this.noLineCheckAll = checkedCount === this.noLineOptions.length
      this.noLineIsIndeterminate =
        checkedCount > 0 && checkedCount < this.noLineOptions.length
    },
    // 确认导出
    onNoLineSureExport() {
      const vm = this
      vm.tableLoading = true
      const params = this.getSearchParams()
      let data = {}
      if (vm.searchData) {
        data = {
          ...vm.searchData
        }
      }
      data.selfAreaId = vm.selfAreaId
      data.export =
        vm.noLineCheckedCities && vm.noLineCheckedCities.length
          ? vm.noLineCheckedCities.sort(compare).join(',')
          : ''
      data = getFilterParams(data)
      const newParams = Object.assign(data, params)
      if (data.export) {
        Api.exportNoLineList(this.selfAreaId, newParams).then((res) => {
          if (res.code === 200) {
            downloadExcel(res.data)
            vm.tableLoading = false
            vm.handleNoLineCloseExport()
          } else {
            vm.$message.warning(res.message)
          }
          vm.tableLoading = false
        })
      } else {
        vm.$message.warning('请选择导出字段！')
        vm.tableLoading = false
      }
    }
  },
  components: {
    vButton,
    formButton,
    formData,
    formDataRange,
    formDataTime,
    formDateselect,
    formDataTimeRange,
    formInput,
    formAutocomplete,
    formTextarea,
    formSelect,
    formStatictext,
    formArea,
    formAreaArea,
    formRadio,
    formUpload,
    WDialog,
    WTable,
    vText,
    vTitle,
    vGgContent,
    vGgInfo,
    vSteps,
    vSelect,
    vImage,
    vTable,
    vStatictext
  }
}
</script>

<style lang="less">
@import "../../styles/index.less";
@import "./miBicycle.less";
</style>
